import {Ic} from "../../../models/common";
import {
  Comparator, comparator_AppName,
  comparator_IdLim, comparator_IOUT_max, comparator_log, comparator_PN_PKG, comparator_Priority, comparator_ReleaseDate,
  comparator_Severity,
  comparator_Topology,
  comparator_VinDelta, comparator_VinMax, comparator_VinMin,
  IComparatorFn
} from "../../../models/IComparator";


export class Comparator_AcDc extends Comparator {
  protected get compareDefaultFnsList(): IComparatorFn<Ic>[] {
    return [
//  comparator_log("comparator_Severity"),
      // comparator_Severity, // presente nella versione flash
//  comparator_log("comparator_App Name Html"),
      comparator_AppName,
//  comparator_log("comparator_ReleaseDate"),
      comparator_ReleaseDate,
//  comparator_log("comparator_Priority"),
      comparator_Priority,
//  comparator_log("comparator_IdLim"),
      comparator_IdLim,
//  comparator_log("comparator_IOUT_max"),
      comparator_IOUT_max,
//  comparator_log("comparator_VinDelta"),
      comparator_VinDelta,
//  comparator_log("comparator_VinMax"),
      comparator_VinMax,
//  comparator_log("comparator_VinMin"),
      comparator_VinMin,
//  comparator_log("comparator_PN_PKG"),
      comparator_PN_PKG,
//  comparator_log("comparator_Topology"),
      comparator_Topology];
  }

  protected get compareDefaultFnsListWhenSpecEdited(): IComparatorFn<Ic>[] {
    return [
      comparator_AppName,
      comparator_Priority,
      comparator_IdLim,
      comparator_IOUT_max,
      comparator_VinDelta,
      comparator_VinMax,
      comparator_VinMin,
      comparator_PN_PKG,
      comparator_Topology];
  }
}
